import { computed, onScopeDispose, watch } from 'vue';

import { useAbility } from '@casl/vue';

import { useDevOnlyOverride } from '@/composables/useDevOnlyOverride';
import { useAuthStore } from '@/stores/auth';
import { useMutationReviewBadgeStore } from '@/stores/mutationReviewBadge';
import { mutationReviewNavCount } from '@/stores/mutationReviewNavCount';

// Called once in App, independently of the responsive header icon cluster.
export const useMutationReviewBadgeLifecycle = () => {
  const auth = useAuthStore();
  const ability = useAbility();
  const { unifiedMutationsActive } = useDevOnlyOverride();
  const badge = useMutationReviewBadgeStore();
  const enabled = computed(() => auth.loggedIn
    && ability.can('read', 'Management')
    && unifiedMutationsActive.value);

  watch(enabled, (active) => {
    if (active) badge.start();
    else badge.stop();
  }, { immediate: true, flush: 'sync' });

  watch([enabled, () => badge.count], ([active, count]) => {
    mutationReviewNavCount.value = active ? count : 0;
  }, { immediate: true, flush: 'sync' });

  onScopeDispose(() => {
    badge.stop();
    mutationReviewNavCount.value = 0;
  });
};
